(function () {
  const form = document.getElementById('b2b-registration-form');
  if (!form) return;

  const submitBtn = document.getElementById('b2b-submit-btn');
  const messageEl = document.getElementById('b2b-message');
  const originalBtnText = submitBtn.textContent;

  function showMessage(text, type) {
    messageEl.textContent = text;
    messageEl.className = type === 'success' ? 'b2b-ok' : 'b2b-err';
    messageEl.hidden = false;
    messageEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function resetBtn() {
    submitBtn.disabled = false;
    submitBtn.textContent = originalBtnText;
  }

  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const data = Object.fromEntries(new FormData(form));

    if (data.ico && !/^\d{8}$/.test(data.ico)) {
      showMessage('IČO musí mít přesně 8 číslic.', 'error');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Odesílám...';
    messageEl.hidden = true;

    try {
      const res = await fetch('/apps/b2b-registrace/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      });

      const json = await res.json();

      if (res.ok && json.success) {
        form.reset();
        const msg = json.isNewCustomer
          ? 'Registrace proběhla úspěšně. Zkontrolujte e-mail pro aktivaci účtu.'
          : 'Firemní profil byl vytvořen a přiřazen k vašemu účtu.';
        showMessage(msg, 'success');
        submitBtn.textContent = 'Odesláno ✓';
      } else if (res.status === 409) {
        showMessage(json.error || 'Firma s tímto IČO je již registrována.', 'error');
        resetBtn();
      } else {
        showMessage(json.error || 'Nastala chyba. Zkuste to prosím znovu.', 'error');
        resetBtn();
      }
    } catch {
      showMessage('Nastala chyba připojení. Zkuste to prosím znovu.', 'error');
      resetBtn();
    }
  });
})();
